import { render, staticRenderFns } from "./adminInfo.vue?vue&type=template&id=72cd9bd0"
import script from "./adminInfo.vue?vue&type=script&lang=js"
export * from "./adminInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports